import { esc } from '@/utils/escape';

export function generateServicesHTML(data: any, settings: any): string {
  const items = (data.items || [])
    .map(
      (item: any) => `        <div class="service-card">
          <div class="service-card__icon">${item.icon || "📋"}</div>
          <h3>${esc(item.title)}</h3>
          <p>${esc(item.text)}</p>
        </div>`,
    )
    .join("\n");

  return `  <!-- Services -->
  <section class="services" id="leistungen">
    <div class="container">
      <div class="section-header">
        <h2>${esc(data.title)}</h2>
        <p>${esc(data.subtitle)}</p>
      </div>
      <div class="services__grid">
${items}
      </div>
    </div>
  </section>`;
}
